module.exports = __webpack_public_path__ + "static/media/cross.4748a17e.svg";